import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Table, Col, Row} from "react-bootstrap";
import Header from "../../Components/Header";
import { addPayOut, addPaymentOptions, getPayOut, getPaymentOptions, updatePayOut, updatePaymentOptions } from "../../reducers/commonReducer";
import SideBaar from "../../Components/SideBaar";
import PaymentOptionAction from "./PayoutAction";
import PayoutAction from "./PayoutAction";

const PayoutList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate("/");
    }
    dispatch(getPayOut());
  }, [navigate, dispatch]);
  const { payOutList } = useSelector((state) => state.commonReducer);
  
  return (
    <>
      <Row>  
      <Col md={2} className="p-0"> 
      <SideBaar/>
      </Col> 
      <Col md={10}>
      <Header />
      <div className="container">
        <Row className="mt-4 mb-2 user-table">
          <Col md={6}>
            <h3>Payout</h3>
          </Col>
          <Col md={6}>
            <PayoutAction api={addPayOut} btnTitle={"Add"} btnFloat={"float-right"}/>
          </Col>
        </Row>
        <hr/>
        <div className="overflow-auto">
          <Table striped bordered hover size="sm" className="overflow-scroll">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Name</th>
                <th>Label</th>
                <th>Payout Url</th>
                <th>Verify Url</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!!payOutList &&
                payOutList?.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{data?.name}</td>
                      <td>{data?.label}</td>
                      <td>{data?.payouturl}</td>
                      <td>{data?.verifyurl}</td>
                      <td>{data?.status ? <span className="text-success"><b>Active</b></span> : <span className="text-danger"><b>InActive</b></span>}</td>
                      <td><PayoutAction api={updatePayOut} id={data?.id} label={data?.label} name={data?.name} payouturl={data?.payouturl} verifyurl={data?.verifyurl} status={data?.status}/></td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>
      </Col>
      </Row>
    </>
  );
};

export default PayoutList;
